module.exports = __webpack_public_path__ + "img/icon-ticket-refund.786ed6f3.svg";